<div id="site-content-wrapper" class="mat-typography">
  <span class="hidden-print">
    <summit-header
         [imagesURL]="imagesURL"
         [alertsURL]="alertsServices"
         [isProduction]="isProduction"
         [isStrippedDownHeader]="true">
     </summit-header>
   </span>
  <div class="app-header--unsecure-app">
    <span class="app-header--title-text"><i>Know</i> the People Who Know Workers' Comp.<span class="trademark">&reg;</span></span>
  </div>
    <h1>Changes deployed successfully!!</h1>
  <div id="app-content-wrapper">
    <div id="app-static-content">
      <router-outlet></router-outlet>
    </div>
    <div class="assistance-wrapper">
      <span><strong>Need assistance? Contact our help desk at <span class="no-line-breaking"><a href="tel:+18002827648">1-800-282-7648</a></span></strong></span>
    </div>
  </div>
  <span class="hidden-print">
    <summit-footer
         [imagesURL]="imagesURL"
         [isProduction]="isProduction"
         [appProgrammaticName]="appProgrammaticName">
    </summit-footer>
  </span>
</div>
